
import {useContext} from "react";


//context
import { ContentAudienceContext } from "./ContentAudienceContext";

//components

import LinkStyleButton from "../global/buttons/LinkStyleButton";
import FilterControlsWrapper from "./FilterControlsWrapper";
import { SimpleSearchInput } from "thrive-components";



export const AudienceModalSearchAndFilter = ({isAddGroup}:{isAddGroup?: boolean}) => { 
    const {
        currentSelection,
        setCurrentSelection,
        searchValue,
        setSearchValue,
        filterOptions,
        setFilterOptions,
        filterIsOpen,
        setFilterIsOpen,
        usersOrGroupsLoading,
        groupFilters
    } = useContext(ContentAudienceContext)

    function toggleCurrentSelection(currentComparitor: string){
        return currentSelection === currentComparitor ? 'isActive' : ''
    }

    function handleToggleFilter(option: string){
        if (filterOptions.includes(option)) {
            setFilterOptions(filterOptions.filter(fo => fo !== option))
        } else {
            setFilterOptions([...filterOptions, option])
        }
    }


    function getFilterText(){
        let filterText = 'Filter'

        if(filterOptions.length + groupFilters.length >= 1) {
            filterText += ` (${filterOptions.length + groupFilters.length})`
        }

        return filterText;
    }

    return (
        <div className={`audience-modal-search-and-filter-wrapper ${filterIsOpen ? 'filter-open' : 'filter-close'}`}>
            <div className='audience-modal-search-and-filter-controls-wrapper'>
                <div className='audience-modal-search-and-filter-controls-tabs-wrapper'>
                    {!isAddGroup &&  <>
                        <LinkStyleButton 
                            content={'Groups'}
                            className={toggleCurrentSelection('Groups')}
                            onButtonClick={() => setCurrentSelection('Groups')} ariaLabel={'Edit Audience By Group'}
                            isDisabled={usersOrGroupsLoading}
                        />
                        <LinkStyleButton
                            content={'Users'}
                            className={toggleCurrentSelection('Users')}
                            onButtonClick={() => setCurrentSelection('Users')}
                            ariaLabel={'Edit Audience By User'}
                            isDisabled={usersOrGroupsLoading}
                        />
                    </> }
                </div>

                <div className='audience-modal-search-and-filter-controls'>
                    <LinkStyleButton
                        className="filter-button"
                        content={getFilterText()}
                        onButtonClick={() => setFilterIsOpen(!filterIsOpen)}
                        ariaLabel={'View Filter Options'}
                    />
                    
                    <SimpleSearchInput
                        ariaLabel="search for users or groups"
                        setSearchString={setSearchValue}
                        searchString={searchValue}
                    />
                </div>
            </div>

            {filterIsOpen && <FilterControlsWrapper 
                handleToggleFilter={handleToggleFilter}
            />}
        </div>
    )
}

export default AudienceModalSearchAndFilter;


